var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83345 11.6667C5.8334 11.7751 5.86355 11.8813 5.92053 11.9736C5.97751 12.0658 6.05906 12.1403 6.15603 12.1887L7.3227 12.7721C7.41165 12.8165 7.5105 12.8375 7.60984 12.833C7.70918 12.8285 7.80573 12.7987 7.8903 12.7464C7.97487 12.6941 8.04467 12.621 8.09306 12.5341C8.14145 12.4472 8.16683 12.3494 8.16678 12.25V8.16667C8.16691 7.87756 8.27439 7.59879 8.46837 7.38442L12.6818 2.72417C12.7573 2.64049 12.807 2.53673 12.8248 2.42543C12.8426 2.31413 12.8277 2.20006 12.7821 2.09701C12.7364 1.99396 12.6619 1.90635 12.5675 1.84476C12.4731 1.78318 12.3628 1.75027 12.2501 1.75H1.75012C1.6373 1.75004 1.52692 1.78279 1.43234 1.84429C1.33777 1.90578 1.26305 1.99338 1.21724 2.09648C1.17144 2.19957 1.15651 2.31374 1.17426 2.42514C1.19202 2.53655 1.2417 2.64042 1.31728 2.72417L5.53186 7.38442C5.72584 7.59879 5.83332 7.87756 5.83345 8.16667V11.6667Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.de0c50404d5777780ce4fa41d5699779.svg";
export { ForwardRef as ReactComponent };